import { cloneDeep } from 'lodash/lang'
import { selectProduct } from 'lib/cart/services/selection'

// store the selected product for the given camper and session
const setCartProduct = (state, action) => {
  const { camper, session, camperSession, product, selectedType } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // set selected product for the appropriate cart product, optionally setting
  // days selection
  selectProduct(product, {
    camper,
    session,
    camperSession,
    selectedType,
    cartForm
  })

  // return a new state object
  return cartForm
}

export default setCartProduct
